import { useTranslation } from '@mint-lib/i18n';

import { Box, Button, CheckboxWithLabel, Typography } from '@myn/mui';

type Props = {
  options: { value: string; displayName: string }[];
  areAllSelected: boolean;
  selectedValues: string[] | null;
  onClickSelectAll: () => void;
  onChangeDay: (day: string) => void;
  handleApply: () => void;
  handleCloseModal: () => void;
};

const DaySelectModal = ({
  options,
  areAllSelected,
  selectedValues,
  onClickSelectAll,
  onChangeDay,
  handleApply,
  handleCloseModal,
}: Props) => {
  const { t } = useTranslation('@myn/planning');

  return (
    <Box sx={{ padding: (theme) => theme.spacing(2) }}>
      <Button variant="text" onClick={onClickSelectAll} sx={{ padding: 0 }}>
        <Typography variant="h6" color={({ palette }) => palette.text.primary}>
          {areAllSelected ? t('Clear all') : t('Select all')}
        </Typography>
      </Button>
      <Box
        sx={{
          mb: '16px',
          width: '100px',
        }}
      >
        {options.map((day) => (
          <CheckboxWithLabel
            key={day.value}
            onChange={() => onChangeDay(day.value)}
            checked={!!selectedValues?.includes(day.value)}
            label={day.displayName}
          />
        ))}
      </Box>
      <Button variant="text" onClick={handleCloseModal} sx={{ mr: '8px' }}>
        {t('Cancel')}
      </Button>
      <Button
        variant="contained"
        onClick={handleApply}
        disabled={!selectedValues?.length}
      >
        {t('Apply')}
      </Button>
    </Box>
  );
};

export default DaySelectModal;
